import { render, staticRenderFns } from "./CartSteps.vue?vue&type=template&id=3a9f64b5&scoped=true&lang=pug&"
import script from "./CartSteps.vue?vue&type=script&lang=ts&"
export * from "./CartSteps.vue?vue&type=script&lang=ts&"
import style0 from "./CartSteps.vue?vue&type=style&index=0&id=3a9f64b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9f64b5",
  null
  
)

export default component.exports